export default "__VITE_ASSET__DJd1ycPz__"